import { get2ndNumber } from "./number.js";

get2ndNumber([{n:1}, {n: null}]);